import ArgumentDefinition from '../../../../types/functions/ArgumentDefinition';
import copyArray from '../../../../infrastructure/helpers/common/copyArray';
import CustomDataSourceFields from '../../../../types/report/CustomDataSourceFields';
import functionDisplayHelper from '../../../../infrastructure/helpers/functions/function/functionDisplayHelper';
import functionHelper from '../../../../infrastructure/helpers/functions/function/functionHelper';
import getFunctionArgument from './getArgument';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Lookup from '../../../../types/functions/Lookup';
import Operand from '../../../../types/functions/Operand/Operand';
import React from 'react';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import ReportVariable from '../../../../types/report/ReportVariable';
import functionName from '../../../../infrastructure/constants/functions/definition/functionName';
import './styles.scss';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import Dictionary from '../../../../types/report/Dictionary';
import stringHelper from '../../../../infrastructure/helpers/common/stringHelper';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import Aggregation from '../../../../types/report/Aggregation';
import ReportCase from '../../../../types/report/ReportCase';
import actions from '../../../../store/actions';
import store from '../../../../store/store';
import MoreArgumentsState from '../../Arguments/MoreArgumentsState';

interface FunctionOperandProps {
    operand: Operand,
    operandNumber: number,
    argumentIndexes: number[],
    functions: UserDefinedFunction[],
    lookups: Lookup[],
    dictionaries: Dictionary[],
    variables: ReportVariable[],
    dataSources: IngestionConfig[],
    reportFields: ReportFieldDefinition[],
    customDataSourceFields: CustomDataSourceFields,
    selectorNumber: number | null,
    onClick: (operandNumber: number, argumentIndexes: number[], event: React.MouseEvent<HTMLElement>) => void,
    disabled: boolean,
    reportConfigType: string,
    location?: ReportLogicLocation,
    cases?: ReportCase[],
    aggregations?: Aggregation[],
    children?: JSX.Element,
    globalFunctions: UserDefinedFunction[],
}

class FunctionOperand extends React.Component<FunctionOperandProps, { showArgumentsModal: boolean, initialArguments: Operand[], error: string | null }> {

    defaultArgumentCount = 3;

    constructor(props: FunctionOperandProps) {
        super(props);

        this.state = {
            showArgumentsModal: false,
            initialArguments: [],
            error: null
        }
        this.onButtonMoreArgumentsClick = this.onButtonMoreArgumentsClick.bind(this);
        this.isArrayFunction = this.isArrayFunction.bind(this);
    }

    addComma(i: number, args: Operand[], isMethod: boolean, isOperator: boolean): boolean {
        if (isOperator) {
            return false;
        }

        return (
            (i > 0 || !isMethod) &&
            (i < args.length - 1)
        );
    };

    buildArgumentDescription(definition: ArgumentDefinition): string {

        return `${definition.name}: ${definition.allowedTypes.join(' | ')}`;
    };

    removeHiddenArguments(hiddenDataTypeArguments: string[], args: Operand[]): Operand[] {
        return args.filter(a => !hiddenDataTypeArguments.includes(a.dataType));
    }

    onButtonMoreArgumentsClick() {

        store.dispatch({
            type: actions.moreArgumentsModal.open, payload: {
                argumentIndexes: this.props.argumentIndexes,
                customDataSourceFields: this.props.customDataSourceFields,
                variables: this.props.variables,
                lookups: this.props.lookups,
                dataSources: this.props.dataSources,
                dictionaries: this.props.dictionaries,
                functions: this.props.functions,
                disabled: this.props.disabled,
                globalFunctions: this.props.globalFunctions,
                onClick: this.props.onClick,
                operand: this.props.operand,
                operandNumber: this.props.operandNumber,
                reportConfigType: this.props.reportConfigType,
                reportFields: this.props.reportFields,
                selectorNumber: this.props.selectorNumber,
                aggregations: this.props.aggregations,
                cases: this.props.cases,
                location: this.props.location
            } as MoreArgumentsState
        });
    }

    isArrayFunction(): boolean {

        let isFunction = stringHelper.isNonEmpty(this.props.operand.function);
        if (!isFunction) {
            return false;
        }

        return functionHelper.isArrayFunction(this.props.operand.function);
    }

    render() {
        let definition = functionHelper.getFunctionDefinition(this.props.operand.function);
        switch (this.props.operand.function) {
            case functionName.activeOnTradingDate:
                if (definition.hiddenDataTypeArguments) {
                    let newArgs: Operand[] = this.removeHiddenArguments(definition.hiddenDataTypeArguments as string[], this.props.operand.arguments as Operand[]);
                    this.props.operand.arguments = newArgs;
                }
                break;
            default: break;
        }

        let tooltips = functionHelper.getArgumentDescriptions(this.props.operand.function, this.buildArgumentDescription);

        let args: JSX.Element[] = (this.props.operand.arguments as Operand[])
            .map((x, i, arr) => getFunctionArgument(x, this.props.operandNumber, copyArray(this.props.argumentIndexes).concat([i]), tooltips[i],
                this.props.functions, this.props.globalFunctions, this.props.lookups, this.props.dictionaries, this.props.variables, this.props.dataSources, this.props.reportFields,
                this.props.customDataSourceFields, this.props.selectorNumber, this.props.onClick, i,
                this.addComma(i, arr, definition.isMethod, !!definition.operator), this.props.disabled,
                this.props.reportConfigType,
                this.props.location, this.props.cases, this.props.aggregations));

        return (
            <div className='max-width-1000px'>
                {definition.operator ?
                    <div className='flex-wrap'>
                        <span className="code">(</span>
                        {args[0]}

                        <button className="transparent-button code function" onClick={(event) => this.props.onClick(this.props.operandNumber, this.props.argumentIndexes, event)} disabled={this.props.disabled} title={definition.description}>
                            {definition.operator}
                        </button>

                        {args[1]}
                        <span className="code">)</span>
                    </div>
                    :
                    <div className='flex-wrap'>
                        {definition.isMethod && args[0]}
                        <div className='align-items-start flex-wrap'>
                            {definition.isMethod && <span className="code">.</span>}

                            <button className="transparent-button code function" onClick={(event) => this.props.onClick(this.props.operandNumber, this.props.argumentIndexes, event)} disabled={this.props.disabled} title={definition.description}>
                                {functionDisplayHelper.getDisplayName(this.props.operand.function)}
                            </button>
                            {!definition.operator && !this.state.showArgumentsModal ? <>
                                <span className="code">(</span>
                                {args.slice(definition.isMethod ? 1 : 0).slice(0, this.defaultArgumentCount)}
                                {this.isArrayFunction() && (this.props.operand.arguments?.length || 0) - (definition.isMethod ? 1 : 0) > this.defaultArgumentCount &&
                                    <button className='transparent-button code function' onClick={this.onButtonMoreArgumentsClick}>...More</button>
                                }
                                <span className="code">)</span>
                                {this.props.children}
                            </>
                                : null}
                        </div>
                    </div>
                }
            </div>
        );
    };
}

export default FunctionOperand;